function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var template = require('./radioButtons.jsx');

var displayNames = require('../displayNames');

var _require = require('../radioButtonsHelpers'),
    generateChildrenFromOptions = _require.generateChildrenFromOptions;

var validateOptions = function validateOptions(props, propName, compName, locationName) {
  if (_.isEmpty(props[propName]) === _.isEmpty(props.children)) {
    return new Error("Exactly one of ".concat(propName, " property and children can be specified in ").concat(compName, "."));
  }

  var optionsType = {
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string,
      disabled: PropTypes.bool
    }))])
  };
  PropTypes.checkPropTypes(optionsType, props, locationName, compName);
};

var RadioButtons = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioButtons, _React$Component);

  var _super = _createSuper(RadioButtons);

  function RadioButtons(props) {
    var _this;

    _classCallCheck(this, RadioButtons);

    _this = _super.call(this, props);
    _this.groupId = _.uniqueId('radioGroup');

    _this.generateChildren = function () {
      return _this.props.options ? generateChildrenFromOptions(_this.props) : _.castArray(_this.props.children);
    };

    return _this;
  }

  _createClass(RadioButtons, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return RadioButtons;
}(React.Component);

RadioButtons.displayName = displayNames.RADIO_BUTTONS;
RadioButtons.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  labelTemplate: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  // React class / functional comp
  options: validateOptions,
  disabled: PropTypes.bool,
  radioItemPredicate: PropTypes.func,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  showRadioSymbol: PropTypes.bool
};
RadioButtons.defaultProps = {
  disabled: false,
  radioItemPredicate: function radioItemPredicate(item) {
    return _.has(item, 'props.value');
  },
  orientation: 'vertical',
  showRadioSymbol: true
};
module.exports = compose(RadioButtons);